import { EDX_API_ENDPOINTS } from 'config';
import { getPanelLmsBaseUrl } from 'helpers';
import { axiosInstance } from 'helpers/cacheApiClient';
import { userSites } from 'helpers/constants';

export const userSiteService = {
  fetchUserSites
};

async function fetchUserSites() {
  const url = `${getPanelLmsBaseUrl()}${EDX_API_ENDPOINTS.USER_SITES}`;
  const requestOptions = {
    method: 'GET',
    withCredentials: true,
    id: userSites,
    cache: {
      ttl: 1000 * 60 * 60 * 24 * 7 // 7 days
    },
    url
  };
  return await axiosInstance(requestOptions);
}
